import React from "react";
import DashboardScreenshot from "../../../../assets/images/dashboard-backdrop.png";

/**
 * Step 2 backdrop — a blurred screenshot of the real Linked Accounts dashboard
 * sitting fixed behind the modal. Hidden below 768px (D14) via `hidden md:block`.
 * Replace the PNG whenever the dashboard UI shifts meaningfully.
 */
const DashboardBackdrop = () => (
  <div
    aria-hidden
    className="hidden md:block fixed inset-0 -z-10 overflow-hidden pointer-events-none"
  >
    <img src={DashboardScreenshot} alt="" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-gray-90/[0.48] backdrop-blur-[8.5px]" />
  </div>
);

export default DashboardBackdrop;
